import React from "react";
import ServiceTable from "./ServiceTable";
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

function ServiceReport(props) {
    return (
        <>
            <label>Štatistika prípadov</label>
            <Tabs>
                {props.data && Object.entries(props.data).map(([key, value], index) => {
                    return (
                    <Tab eventKey={key} title={key}>
                        <ServiceTable key={index} data={value}/>
                    </Tab>
                    )
                })}
            </Tabs>
        </>
    )
}

export default ServiceReport
